<template>
  <div id="app">
    <Dashboard />
  </div>
</template>

<script>
import Dashboard from "./views/dashboard/index.vue";
export default {
  name: "App",
  components: {
    Dashboard,
  },
};
</script>

<style>
body {
  margin: 0;
  color: #a0e3ff;
}
#container {
  position: fixed;
  top: 0;
  width: 100%;
}
canvas {
  position: unset !important;
}
.dp-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.h-100 {
  height: 100%;
}
.dv-border-box-4 {
  flex-basis: 33.33%;
  flex-grow: 1;
  height: 33.33% !important;
}

.status {
  color: lime;
}
.status1 {
  color: yellow;
}
.status2 {
  color: red;
}
</style>
